
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { MenuComponent } from "@/assets/ts/components";
import { useI18n } from "vue-i18n";
import mixin from "@/mixins";
import { ApiPayment } from "@/core/api";
import {
  paymentOverviewData,
  PaymentStatus,
} from "@/core/directive/interface/payment";
import { getPaymentStatus } from "@/core/directive/function/paymentManagement";
import { formatDate } from "@/core/directive/function/common";
import _ from "lodash";
import AddRefundModal from "@/views/payment-management/refund/AddRefundModal.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import base from "@/core/api/base";

export default defineComponent({
  name: "payment-management-payment-detail",
  components: { AddRefundModal },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const router = useRouter();

    const { showServerErrorMsg } = mixin();

    const loading = ref(false);

    const baseData = ref(Object.assign({}, _.cloneDeep(paymentOverviewData)));

    const getShowInfo = async () => {
      // loading.value = true;
      const { data } = await ApiPayment.showPayment({ id: route.params.id });
      // loading.value = false;
      if (data.code == 0) {
        baseData.value = data.data;
      } else {
        showServerErrorMsg(data);
      }
    };

    const getFromInfo = async () => {
      loading.value = true;
      Promise.all([getShowInfo()])
        .then(() => {
          loading.value = false;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const getStatusClass = computed(() => {
      return (status) => {
        return getPaymentStatus(status);
      };
    });

    const cancelPayment = async (id) => {
      loading.value = true;
      const { data } = await ApiPayment.cancelPayment({
        id: id,
      });
      loading.value = false;
      if (data.code == 0) {
        getShowInfo();
        Swal.fire({
          text: t("payment.cancelSuccessMsg"),
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: t("common.okGotIt"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      }
    };

    const onCancelButtonClick = (id) => {
      Swal.fire({
        text: t("payment.cancelConfirmMsg"),
        icon: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: t("common.confirm"),
        cancelButtonText: t("common.cancel"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          cancelPayment(id);
        }
      });
    };

    const backToList = () => {
      router.replace("/payment-management/payment");
    };

    onMounted(() => {
      MenuComponent.reinitialization();
      getFromInfo();
    });

    return {
      loading,
      baseData,
      t,
      formatDate,
      getShowInfo,
      getFromInfo,
      getStatusClass,
      backToList,
      onCancelButtonClick,
      PaymentStatus,
    };
  },
});
